import { render } from "./WithCart.vue?vue&type=template&id=64f2041a"
import script from "./WithCart.vue?vue&type=script&lang=js"
export * from "./WithCart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__